import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DataStateChangeEventArgs } from '@syncfusion/ej2-angular-grids';
import { Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { ErrorService } from 'src/app/error.service';
import { getEvvtimesheetBO } from '../evvtimesheet.model';

@Injectable({
    providedIn: 'root'
})
export class EvvTimesheetDateListService extends Subject<DataStateChangeEventArgs> {

    constructor(private http: HttpClient, public errorService: ErrorService,
    ) { super() }
    public execute(Timesheetstate: getEvvtimesheetBO): void {
        this.getTimesheetList(Timesheetstate).subscribe(x => super.next(x));
    }
    getTimesheetList(Timesheetstate?: getEvvtimesheetBO): Observable<DataStateChangeEventArgs> {
        return this.http.post<any>("api/Visit/GetVisit", Timesheetstate)
            .pipe(map(
                (response: any) =>
                    <any>{
                        result: response['result'],
                        count: response['count'],
                        
                    }
            ))
            .pipe(map((data:any) => {    
                data.result=this.getErrorData(data);
                return data;
              }) )  


    }

getErrorData(data){
    console.log(data);
      let getdata=data.result
      getdata?.forEach(e=>{
        let result = e.errorList?.filter(s=> s.valid != 'Valid')
            e.validate=result?.length > 0 ? false : true
            if(e.visitEndTime=="0001-01-01T00:00:00"){
                e.visitEndTime=''
            }
        return;
    })
    console.log(getdata,"errorlist ")   
    return getdata;
    }
    
}

